import React, { useEffect } from "react";
import "./Products.css";
import productData from "./productData";
import ProductCard from "./ProductCard";

const Products = () => {
  /* 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye ho to "smooth"
    });
  }, []);

  return (
    <section className="products-section">
      <section className="section-title">
        <h1>THE CHALO COLLECTION</h1>
        <p>WHERE INNOVATION MEETS LUXURY</p>

        <div className="divider">
          <span></span>
          <div className="diamond"></div>
          <span></span>
        </div>
      </section>

      <div className="products-grid">
        {productData.map((item) => (
          <ProductCard key={item.id} product={item} />
        ))}
      </div>
    </section>
  );
};

export default Products;
